import {
  BibliographyContentDetailBibliography,
  BibliographyContentDetailBibliographyFromJSON,
  defaultBibliographyContentDetailBibliography,
  BibliographyContentDetailDetail,
  BibliographyContentDetailDetailFromJSON,
  BibliographyDetailAuthority,
  BibliographyAuthorityFromJSON
} from '.'

export interface BibliographyContentDetail {
  bibliography: BibliographyContentDetailBibliography
  details: BibliographyContentDetailDetail[]
  authorities: BibliographyDetailAuthority[]
}

export function BibliographyContentDetailFromJSON(
  json: any
): BibliographyContentDetail {
  return {
    bibliography: BibliographyContentDetailBibliographyFromJSON(
      json.bibliography
    ),
    details: json.bibliography_details.map(
      BibliographyContentDetailDetailFromJSON
    ),
    authorities: json.bibliography_authorities.map(
      BibliographyAuthorityFromJSON
    )
  }
}

export const defaultBibliographyContentDetail = (): BibliographyContentDetail => ({
  bibliography: defaultBibliographyContentDetailBibliography(),
  details: [],
  authorities: []
})
